/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CannotProcessFee.module.scss'
import { useHistory } from 'react-router-dom'

const CannotProcessFeeView = ({ t, i18n }) => {
  const history = useHistory()

  const nsLocationsURL = i18n.language === 'en' ? 'https://novascotia.ca/access-locations/' : 'https://novascotia.ca/access-locations/fr/'

  const getPayAFineUrl = () => {
    const origin = window.location.origin;
    if (origin.includes('dev-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-finepayments.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://dev-finepayments.ds4u.novascotia.dev/fr/avis-de-confidentialite';
    } else if (origin.includes('test-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-finepayments.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://test-finepayments.ds4u.novascotia.dev/fr/avis-de-confidentialite';
    } else if (origin.includes('uat-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-finepayments.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://uat-finepayments.ds4u.novascotia.dev/fr/avis-de-confidentialite';
    } else {
      return i18n.language === 'en'
        ? 'https://finepayment.novascotia.ca/en/privacy-notice'
        : 'https://finepayment.novascotia.ca/fr/avis-de-confidentialite';
    }
  }

  const getPhoneNumber = () => {
    return `tel:${t('cannot_process_fee.number')}`
  }

  const payAFineUrl = getPayAFineUrl();

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>{t('cannot_process_fee.we_cannot_process')}</h3>
          <ul>
            <li>{t('cannot_process_fee.your_information_either')}</li>
            <li>
              <a
                onClick={() => history.push(`/${i18n.language}${t('routes.your_info')}`)}
                href={`/${i18n.language}${t('routes.your_info')}`}
              >
                {t('cannot_process_fee.go_back')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              .
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={payAFineUrl}
              >
                {t('cannot_process_fee.pay_any_outstanding')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              .
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>{t('cannot_process_fee.if_you_are_still')}</h3>
          <ul>
            <li>
              {t('cannot_process_fee.for_more_information')}
              <a href={getPhoneNumber()}>{t('cannot_process_fee.number')}<span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span></a>
              {t('cannot_process_fee.or_visit_an')}
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://novascotia.ca/access-locations/'
                    : 'https://novascotia.ca/access-locations/fr/'
                }
              >
                {t('cannot_process_fee.find_out_more')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              .
            </li>
          </ul>
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <div style={{ display: 'flex' }}>
          <button
            className={['btn-lg btn-default', styles['margin_zero']].join(' ')}
            onClick={() => window.location.assign(nsLocationsURL)}
            name={t('cannot_process_fee.find_a_location')}
            value={t('cannot_process_fee.find_a_location')}
          >
            {t('cannot_process_fee.find_a_location')}
          </button>
          <div className={styles['cancel_center_margin']}>
            <a
              href={
                i18n.language === 'en'
                  ? 'https://beta.novascotia.ca/pay-privilege-reinstatement-fee-registry-motor-vehicles'
                  : 'https://beta.novascotia.ca/fr/paiement-des-frais-de-retablissement-de-permis-de-conduire-bureau-des-vehicules-automobiles'
              }
            >
              {t('cannot_process_fee.cancel')}
              <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={styles['margin_back']}>
        <div className="row">
          <div className="col-xs-12">
            <a onClick={() => history.push(`/${i18n.language}${t('routes.your_info')}`)} href={`/${i18n.language}${t('routes.your_info')}`}>
              {t('cannot_process_fee.back')}
              <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(CannotProcessFeeView)
